(($) => {
    const $sliderModule = $('.fl-module-lum-broker-slider');
    const $eventsListModule = $('.fl-module-lum-broker-events-list');
    const $eventsListContainer = $eventsListModule.find('.container-fluid');

    window.addEventListener('load', init);
    
    function init() {
        if ($sliderModule.length > 0 && $eventsListModule.length > 0) {
            updateHeights();
        }

        bind();
    }

    function bind() {
        if ($sliderModule.length > 0 && $eventsListModule.length > 0) {
            $sliderModule.on('bb-lumeris:lum-broker-slider:afterInit', onSliderAfterInit);
            $sliderModule.on('bb-lumeris:lum-broker-slider:resize', onSliderResize);
            $sliderModule.on('bb-lumeris:lum-broker-slider:updateLayout', onSliderUpdateLayout);
        }
    }

    function updateHeights() {
        $eventsListContainer.height($sliderModule.height());
    }

    function onSliderAfterInit(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
        updateHeights();
    }

    function onSliderResize(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
        updateHeights();
    }

    function onSliderUpdateLayout(event, data) {
        if (!(event instanceof Object) || !(data instanceof Object)) {
            return null;
        }
        updateHeights();
    }
    
})(jQuery);